__turbopack_context__.v({
  "badge": "ProductSeries-module-scss-module__SHwR5W__badge",
  "left": "ProductSeries-module-scss-module__SHwR5W__left",
  "modalImage": "ProductSeries-module-scss-module__SHwR5W__modalImage",
  "navArrow": "ProductSeries-module-scss-module__SHwR5W__navArrow",
  "right": "ProductSeries-module-scss-module__SHwR5W__right",
  "typeFilters": "ProductSeries-module-scss-module__SHwR5W__typeFilters",
});
